import CustomerMapMarker from './CustomerMapMarker';

export default CustomerMapMarker;
